import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";          // hero-icons for the burger
import "./Navbar.css";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  const close  = () => setOpen(false);

  return (
    <header className="navbar">
      <div className="navbar__inner">
        {/* Logo */}
        <Link to="/" className="logo" onClick={close}>
          Quick<span>Fit</span>
        </Link>


        {/* Links */}
        <nav className={`nav-links ${open ? "open" : ""}`}>
          <NavLink to="/brands"   onClick={close}>Brands</NavLink>
          <NavLink to="/blog"     onClick={close}>Blog</NavLink>
          <NavLink to="/about"    onClick={close}>About</NavLink>
          <NavLink to="/support"  onClick={close}>Support</NavLink>

          <div className="auth">
            <NavLink to="/login"  className="login-btn"  onClick={close}>Login</NavLink>
            <NavLink to="/signup" className="signup-btn" onClick={close}>Sign up</NavLink>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
